import { render, staticRenderFns } from "./TemplateReplaceForm.vue?vue&type=template&id=10f74279&scoped=true"
import script from "./TemplateReplaceForm.vue?vue&type=script&lang=js"
export * from "./TemplateReplaceForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateReplaceForm.vue?vue&type=style&index=0&id=10f74279&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f74279",
  null
  
)

export default component.exports